import { reportGraphqlError } from "@lib/errorTracking";
import { Client, cacheExchange, fetchExchange, mapExchange } from "urql";

function getCsrfToken(): string {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta?.getAttribute("content") || "";
}

export const graphqlClient = new Client({
  url: "/graphql",
  // urql v5 defaults preferGetMethod to "within-url-limit", but the server
  // route is POST-only (GET enables cookie-riding CSRF — see #2683).
  preferGetMethod: false,
  exchanges: [
    cacheExchange,
    // Every failed operation reaches Honeybadger (#3172) — components may
    // still swallow `error`, but we get to hear about it.
    mapExchange({ onError: reportGraphqlError }),
    fetchExchange,
  ],
  fetchOptions: () => ({
    headers: {
      "X-CSRF-Token": getCsrfToken(),
      "Content-Type": "application/json",
    },
  }),
});
